import MathFactSeedDataModel from './seed_data/math_fact_seed_data_model';
import MathFactReportingModel from './seed_data/math_fact_reporting_model';
import MathFactAssignmentDetailsModel from './seed_data/math_fact_assignment_details_model'

export const DataModels = {
    MathFactSeedDataModel,
    MathFactReportingModel,
    MathFactAssignmentDetailsModel
}